import "./FilterToggle.scss";
export function FilterToggle({ value = true, updateValue, children, color }) {
	return (
		<label
			className={"filter-toggle"}
			style={{ "--color": color, "--ring-color": `${color}99` }}>
			<input
				type={"checkbox"}
				checked={value}
				onChange={(e) => {
					if (updateValue) {
						updateValue(!value);
					}
				}}
			/>
			<div className={"filter-toggle__label"}>
				<div className={"filter-toggle__bubble"} />
				{children}
			</div>
		</label>
	);
}
